import React from 'react';
import { T } from '../tokens';
import TemplateCardHeader from './TemplateCardHeader';
import TemplateCardPreview from './TemplateCardPreview';
import TemplateCardStats from './TemplateCardStats';
import TemplateCardActions from './TemplateCardActions';

export default function TemplateCard({
  template, onEdit, onToggleStatus, onDelete, toggling,
}) {
  return (
    <div
      className="sma-card-hover"
      style={{
        background: T.card,
        border: `1px solid ${T.line}`,
        borderRadius: 16,
        padding: '18px 20px',
        minWidth: 0,
        overflow: 'hidden',
      }}
    >
      <TemplateCardHeader
        template={template}
        onToggleStatus={onToggleStatus}
        onDelete={onDelete}
        toggling={toggling}
      />
      <TemplateCardPreview template={template} />
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 14,
        paddingTop: 14,
        borderTop: `1px solid ${T.lineSoft}`,
        flexWrap: 'wrap',
        gap: '8px 12px',
      }}
      >
        <TemplateCardStats template={template} />
        <TemplateCardActions
          template={template}
          onEdit={onEdit}
          onToggleStatus={onToggleStatus}
          toggling={toggling}
        />
      </div>
    </div>
  );
}
